var map = {
	"./check.png": "7166",
	"./click.png": "e386",
	"./comment.png": "3eb3",
	"./comments.png": "f73b",
	"./desktop.png": "1595",
	"./discussions.png": "8263",
	"./eye.png": "9083",
	"./follower.png": "b2f7",
	"./like.png": "2859",
	"./mobile.png": "1d04",
	"./nbPerson.png": "bb80",
	"./nbPublication.png": "6b7cb",
	"./profile.png": "7fdb",
	"./save.png": "95b7",
	"./save2.png": "ac56",
	"./share.png": "fc1b",
	"./shared.png": "b761",
	"./thumb-up.png": "a5d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5c07";